// Global Instructions Rule Applied!

import { ActiveRecordsState } from '../../interfaces/active_records.ts'

export const selectActiveRecordById = (
  state: { activeRecords: ActiveRecordsState },
  uuid: string | number | null | undefined
) => {
  if (!uuid || !state.activeRecords) return undefined
  const uuidString = uuid.toString()
  return state.activeRecords.records[uuidString]
}

const selectRecordUsage = (state: { activeRecords: ActiveRecordsState }, uuid: string | number | null | undefined) => {
  if (!uuid || !state.activeRecords) return undefined
  const uuidString = uuid.toString()
  return state.activeRecords.usage[uuidString]
}
